/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Activity_Kind_MemoryInputs */



/**
* | output |
* | --- |
* | "Memory" |
*
* @param {Chat_Activity_Kind_MemoryInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_activity_kind_memory = /** @type {((inputs?: Chat_Activity_Kind_MemoryInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Activity_Kind_MemoryInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Herinnering")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Souvenir")
	return /** @type {LocalizedString} */ ("Memory")
});